import {
  areConsecutiveMonths,
  DEFAULT_TIMEZONE,
  monthKey,
  shiftMonthKey,
} from '@performance-crm/shared';

/** Mes 'YYYY-MM' de hoy en la zona de la empresa (Lima por defecto). */
export function currentMonth(tz: string = DEFAULT_TIMEZONE) {
  return monthKey(new Date(), tz);
}
/**
 * Lista de meses 'YYYY-MM' del más reciente al más antiguo: `n` meses hacia atrás contando el actual y, si se
 * pide, `future` meses hacia adelante (metas por adelantado). Aritmética de año/mes, nunca `setMonth` sobre la
 * fecha de hoy: los días 29, 30 y 31 esa resta se desbordaba y repetía u omitía un mes (ux-equipo-22).
 */
export function monthOptions(n = 12, future = 0, tz: string = DEFAULT_TIMEZONE) {
  const current = currentMonth(tz);
  const out: string[] = [];
  for (let i = future; i > -n; i--) out.push(shiftMonthKey(current, i));
  return out;
}
export const monthLabel = (m: string) =>
  new Intl.DateTimeFormat('es-PE', { month: 'short', year: 'numeric', timeZone: 'UTC' }).format(
    new Date(`${m}-15T00:00:00Z`),
  );

/** Texto corto para un conjunto de meses: "set. 2026", "jun. – set. 2026 (4 meses)" o "ene. 2026, mar. 2026 y jun. 2026". */
export function formatMonthsLabel(months: readonly string[]): string {
  if (months.length === 0) return 'Elige los meses';
  if (months.length === 1) return monthLabel(months[0]!);
  if (areConsecutiveMonths(months))
    return `${monthLabel(months[0]!)} – ${monthLabel(months[months.length - 1]!)} (${months.length} meses)`;
  const labels = months.map(monthLabel);
  return `${labels.slice(0, -1).join(', ')} y ${labels[labels.length - 1]}`;
}
